export const APP_VERSION = "8834fdbde3dcd2e9b4e7b3b05ff3a1ef6e9aeda1";
